<template>
	<v-toolbar-items>
		<dialog-confirm
			v-if="removable"
			:message="message"
			:details="details"
			:cancel-text="$t('GENERAL_BUTTON_CANCEL')"
			:confirm-text="$t('GENERAL_BUTTON_DELETE')"
			v-model="confirmVisible"
			@confirm="remove" />

		<template v-if="!small">
			<v-tooltip bottom v-if="editable">
				<template #activator="data">
					<v-btn icon small v-on="data.on" @click="edit">
						<v-icon :color="toolbarIconColor" :size="toolbarIconSize">mdi-pencil</v-icon>
					</v-btn>
				</template>
				<span>{{ $t('GENERAL_EDIT_MENU_EDIT_TEXT') }}</span>
			</v-tooltip>
			<v-tooltip bottom  v-if="removable">
				<template #activator="data">
					<v-btn icon small v-on="data.on" @click="confirmVisible = true">
						<v-icon :color="toolbarIconColor" :size="toolbarIconSize">mdi-delete</v-icon>
					</v-btn>
				</template>
				<span>{{ $t('GENERAL_EDIT_MENU_DELETE_TEXT') }}</span>
			</v-tooltip>
		</template>
		<v-menu v-else offset-y offset-overflow bottom left>
			<v-btn icon small slot="activator">
				<slot name="icon">
					<v-icon :class="activatorClass" :color="toolbarIconColor" :size="toolbarIconSize">{{ icon }}</v-icon>
				</slot>
			</v-btn>
			<v-list dense>
				<v-list-tile v-if="editable" @click="edit">
					<v-icon :color="toolbarIconColor" :size="toolbarIconSize" class="mr-2">mdi-pencil</v-icon>
					{{ $t('GENERAL_EDIT_MENU_EDIT_TEXT') }}
				</v-list-tile>
				<v-list-tile v-if="removable" @click="confirmVisible = true">
					<v-icon :color="toolbarIconColor" :size="toolbarIconSize" class="mr-2">mdi-delete</v-icon>
					{{ $t('GENERAL_EDIT_MENU_DELETE_TEXT') }}
				</v-list-tile>
			</v-list>	
		</v-menu>
	</v-toolbar-items>
</template>


<script>
import { mapState } from 'vuex';
import DialogConfirm from "@/dialogs/DialogConfirm.vue";

export default {
	name: "menu-edit",
	components: { DialogConfirm },
	props: {
		message: { type: String },
		details: { type: String },
		cancelText: { type: String, default: 'Annuler' },
		confirmText: { type: String, default: 'Supprimer' },
		icon: { type: String, default: 'mdi-dots-horizontal' },
		small: { type: Boolean, default: false },
		editable: { type: Boolean, default: true },
		removable: { type: Boolean, default: true },
	},
	data: () => ({
		confirmVisible: false,
	}),
	computed: {
		...mapState(['toolbarIconColor', 'toolbarIconSize']),
		activatorClass() {
			return this.small ? '' : 'hidden-sm-and-up';
		}
	},
	methods: {
		edit() {
			this.$emit('edit');
		},
		remove() {
			this.$emit('remove');
		},
	},
}
</script>


<style lang="less" scoped>
</style>
